<template>
  <div
    style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: calc(100vh - 64px - 48px); overflow: hidden;"
  >
    <h1 style="text-align: center; color: #666">
      <br>This is your Home Page
      <br>You can edit this page at
      <br>frontend/src/dashboard/dashboard.vue
    </h1>
  </div>
</template>

<script>
export default {
  name: "app-dashboard",
  created() {
     this.$router.push({
        name: "clubList"
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/dashboard/dashboard.vue?45e33677